import { HYDRATE } from "next-redux-wrapper";
import { ActionsPromotion } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storePromotions(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storePromotions };

	}
	case ActionsPromotion.LOAD_GET_PROMOTION:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsPromotion.RES_GET_PROMOTION:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsPromotion.ERR_GET_PROMOTION:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storePromotions;
